import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 表示一个物流模版类型。
 * @enum
 * @version 1.0.0
 */
enum ExpressTemplateType
{
    /**
     * 按件。
     * @member
     */
    pieces = 1,

    /**
     * 按重量。
     * @member
     */
    weight = 2,

    /**
     * 按体积。
     * @member
     */
    bulk = 3,
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(ExpressTemplateType,
{
    pieces:
    {
        alias: "按件数",
        description: {
            unit: "件",
            name:"件"
        }
    },
    weight:
    {
        alias: "按重量",
        description:{
            unit: "kg",
            name:"重"
        }
    },
    bulk:
    {
        alias: "按体积",
        description:{
            unit: "m³",
            name:"体积"
        }
    }
});

export default ExpressTemplateType;
